(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .factory('BlockedTimeReasonSearch', BlockedTimeReasonSearch);

    BlockedTimeReasonSearch.$inject = ['$resource'];

    function BlockedTimeReasonSearch($resource) {
        var resourceUrl =  'api/_search/blocked-time-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
